import { render, staticRenderFns } from "./fccLogsImportacao.vue?vue&type=template&id=c8ab5bd0"
import script from "./fccLogsImportacao.vue?vue&type=script&lang=js"
export * from "./fccLogsImportacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports